import React from 'react';
import { Collapse, Divider, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

interface EmailOriginCollapseProps {
  emailOrigin: {
    from: string;
    subject: string;
    body: string;
  };
  className?: string;
}

const { Panel } = Collapse;

export const EmailOriginCollapse: React.FC<EmailOriginCollapseProps> = ({
  emailOrigin,
  className,
}) => {
  const { t } = useTranslation();

  return (
    <Collapse bordered={false} className={className}>
      <Panel
        header={
          <Typography.Title level={4}>
            {t('contacts:form.labels.originalEmail') || 'Original E-Mail'}
          </Typography.Title>
        }
        key="emailOrigin"
      >
        <div style={{ fontSize: 13, lineHeight: 1.6 }}>
          <div style={{ marginBottom: 8 }}>
            <strong>{t('contacts:form.labels.emailFrom') || 'Von'}:</strong>{' '}
            {emailOrigin.from}
          </div>
          <div style={{ marginBottom: 8 }}>
            <strong>
              {t('contacts:form.labels.emailSubject') || 'Betreff'}:
            </strong>{' '}
            {emailOrigin.subject}
          </div>
          <Divider style={{ margin: '8px 0' }} />
          <div
            style={{
              maxHeight: 300,
              overflow: 'auto',
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
            }}
            dangerouslySetInnerHTML={{ __html: emailOrigin.body }}
          />
        </div>
      </Panel>
    </Collapse>
  );
};

export default EmailOriginCollapse;
